export default {
  title: "Protocolos",
  subtitle: "PDF de la empresa para referencia del personal.",
  empty: "Ningún protocolo coincide con estos filtros.",
  emptyWritable: "Sube el primer protocolo PDF.",
  template: {
    download: "Descargar plantilla",
  },
  filters: {
    searchPlaceholder: "Buscar por título",
    statusLabel: "Estado",
    statusAll: "Todos los estados",
    categoryLabel: "Categoría",
    categoryPlaceholder: "p. ej. Devices, Ops",
    tagLabel: "Etiquetas",
    tagAll: "Todas las etiquetas",
    tagCount: "{{count}} seleccionadas",
  },
  tags: {
    label: "Etiquetas",
    placeholder: "Seleccionar o añadir etiquetas",
    searchPlaceholder: "Buscar etiquetas…",
    create: "Añadir “{{name}}”",
  },
  status: {
    ACTIVE: "Activo",
    SUSPENDED: "Suspendido",
    OBSOLETE: "Obsoleto",
  },
  actions: {
    view: "Ver",
    download: "Descargar",
    edit: "Editar",
    versions: "Versiones",
    addVersion: "Añadir nueva versión",
    markObsolete: "Marcar obsoleto",
    more: "Más acciones",
  },
  obsolete: {
    title: "¿Marcar el protocolo como obsoleto?",
    body: "“{{title}}” saldrá de la lista de Activos. Se conserva el historial de versiones; no se podrán publicar nuevas hasta que vuelva a Activo.",
    confirm: "Marcar obsoleto",
    success: "Protocolo marcado como obsoleto",
  },
  upload: {
    title: "Subir protocolo",
    titleLabel: "Título",
    titlePlaceholder: "p. ej. Plan de evacuación",
    categoryLabel: "Categoría",
    categoryPlaceholder: "p. ej. Devices",
    statusLabel: "Estado",
    fileLabel: "Archivo PDF",
    dropzoneTitle: "Suelta un PDF aquí, o haz clic para elegir",
    dropzoneDescription: "Solo PDF, máx. 20 MB",
    submit: "Subir",
    success: "Protocolo subido",
  },
  edit: {
    title: "Editar protocolo",
    submit: "Guardar",
    success: "Protocolo actualizado",
  },
  versions: {
    title: "Versiones — {{title}}",
    publishTitle: "Añadir nueva versión — {{title}}",
    current: "Actual",
    loadError: "No se pudieron cargar las versiones",
    bumpLabel: "Tipo de versión",
    bumpMinor: "Menor",
    bumpMinorDescription: "Actualizaciones o correcciones pequeñas.",
    bumpMajor: "Mayor",
    bumpMajorDescription: "Reescritura importante o cambio de política.",
    changeSummaryLabel: "Qué cambió",
    changeSummaryPlaceholder: "Notas opcionales sobre lo que cambió en esta versión…",
    changeSummaryHint: "Opcional",
    submit: "Publicar versión",
    success: "Nueva versión publicada",
    publishBlocked:
      "Reactiva este protocolo (estado Activo) antes de publicar una nueva versión.",
  },
  errors: {
    titleRequired: "Introduce un título",
    fileRequired: "Elige un archivo PDF",
    fileTooLarge: "{{name}} es demasiado grande. El tamaño máximo es {{max}}.",
    loadError: "No se pudieron cargar los protocolos",
  },
} as const;
